export type NameLookupEntry = {
  name: string | null;
  isLoading: boolean;
  isError: boolean;
};

export function buildNameLookupMap<TExtra extends Record<string, unknown> = Record<string, unknown>>(
  normalizedIds: Array<string>,
  getEntry: (id: string) => { name: string | null } & TExtra,
  { isLoading, isError }: { isLoading: boolean; isError: boolean },
): Map<string, NameLookupEntry & TExtra> {
  const map = new Map<string, NameLookupEntry & TExtra>();

  normalizedIds.forEach((id) => {
    const entry = getEntry(id);
    map.set(id, {
      ...entry,
      isLoading,
      isError,
    });
  });

  return map;
}
